import React from "react";
import {
  Bell,
  Shield,
  TrendingUp,
  TrendingDown,
  AlertCircle,
} from "lucide-react";
import type { EmailMonitoring } from "../../services/EmailHygieneService";

interface MonitoringStatusProps {
  monitorings: EmailMonitoring[];
  onClick: () => void;
  hasIssues?: boolean;
}

const MonitoringStatus: React.FC<MonitoringStatusProps> = ({
  monitorings,
  onClick,
  hasIssues = false,
}) => {
  const activeMonitorings = monitorings.filter((m) => m.isActive);

  const getOverallTrend = () => {
    if (activeMonitorings.length === 0) return null;

    const trends = activeMonitorings.map((monitoring) => {
      const history = monitoring.analysisHistory;
      if (history.length < 2) return 0;
      return (
        history[history.length - 1].score - history[history.length - 2].score
      );
    });

    const averageTrend = trends.reduce((a, b) => a + b, 0) / trends.length;
    return averageTrend >= 0 ? "improving" : "declining";
  };

  const trend = getOverallTrend();

  return (
    <button onClick={onClick} className="group">
      <div className="flex items-center gap-4 px-5 py-3 bg-white/80 dark:bg-background-paperDark/80 backdrop-blur-sm rounded-xl border border-divider/20 dark:border-divider-dark/20 shadow-lg hover:shadow-xl transition-all duration-300">
        <div className="flex items-center gap-2">
          <Bell className="w-5 h-5 text-yellow-DEFAULT group-hover:scale-110 transition-transform" />
          <div className="text-left">
            <span className="block text-sm font-medium">Monitoring Status</span>
            <span className="text-xs text-text-secondary">
              {activeMonitorings.length} active{" "}
              {activeMonitorings.length === 1 ? "domain" : "domains"}
            </span>
          </div>
        </div>
        {hasIssues && (
          <div className="flex items-center gap-1.5 px-2 py-0.5 bg-red-dark/10 text-red-dark rounded-full text-xs font-medium">
            <AlertCircle className="w-3.5 h-3.5" />
            Issues Found
          </div>
        )}
      </div>
    </button>
  );
};

export default MonitoringStatus;
